import React from 'react';
import { Route } from 'react-router';

import config from '../../config';
import Checkout from './Checkout';
import ViewGiftCard from './ViewGiftCard';
import GiftCardLayout from './GiftCardLayout';
import { getGiftCardUrls } from '../utils/helpers';

const urls = getGiftCardUrls(config.urlPatterns.giftCard);

const GiftCardRoutes = () => (
  <Route component={GiftCardLayout}>
    <Route
      path="/gift-card/:shopRoute/:barberRoute/:giftCardAmount/view"
      component={ViewGiftCard}
    />
    <Route
      path={urls.shopUrl}
      component={Checkout}
    />
    <Route
      path={urls.barberUrl}
      component={Checkout}
    />
    <Route
      path={urls.checkoutUrl}
      component={Checkout}
    />
  </Route>
);

export default GiftCardRoutes;



// WEBPACK FOOTER //
// ./src/app/giftCard/routes.jsx